module.exports = __webpack_public_path__ + "static/media/calculator.0ccc6bd5.svg";